import { Routes } from '@angular/router';
import { OddOneOutMixedPage } from './odd-one-out-mixed-page/odd-one-out-mixed-page';
import { OddOneOutPage } from './odd-one-out-page';
import { OddOneOutSentencesPage } from './odd-one-out-sentences-page/odd-one-out-sentences-page';
import { OddOneOutWordsPage } from './odd-one-out-words-page/odd-one-out-words-page';

export const mechanicOddOneOutRoutes: Routes = [
  {
    path: '',
    component: OddOneOutPage,
  },
  {
    path: 'mixed',
    component: OddOneOutMixedPage,
  },
  {
    path: 'words',
    component: OddOneOutWordsPage,
  },
  {
    path: 'sentences',
    component: OddOneOutSentencesPage,
  },
];
